import styled, { keyframes } from "styled-components"

export const LoadingSpinner = ({ variant = "primary", className }) => {
  return (
    <Spinner
      className={className}
      variant={variant}
    />
  )
}

const spin = keyframes`
  to {
    transform: rotate(1turn);
  }
`

const Spinner = styled.div`
  width: 19px;
  height: 19px;
  padding: 4px;
  aspect-ratio: 1;
  margin-right: 4px;
  border-radius: 50%;
  background: ${({ variant }) => {
    if (variant === "white") return "#edf0ff"
    if (variant === "primary") return "#554df1"
    return "#554df1"
  }};
  --_m: conic-gradient(#0000 10%, #000), linear-gradient(#000 0 0) content-box;
  -webkit-mask: var(--_m);
  mask: var(--_m);
  -webkit-mask-composite: source-out;
  mask-composite: subtract;
  animation: ${spin} 1s infinite linear;
`